import React, { createContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

export const PDFStatusContext = createContext({
    viewerLoaded: false,
    documentLoaded: false,
    draggableReady: false,
    pdfNotProtected: false,
    setViewerLoaded: () => {},
    setDocumentLoaded: () => {},
    setDraggableReady: () => {},
    setPdfNotProtected: () => {},
});

export function PDFStatusProvider({ children }) {
    const [viewerLoaded,   setViewerLoaded]   = useState(false);
    const [documentLoaded, setDocumentLoaded] = useState(false);
    const [draggableReady, setDraggableReady] = useState(false);
    const [pdfNotProtected, setPdfNotProtected] = useState(true);

    const value = useMemo(() => ({
        viewerLoaded,
        documentLoaded,
        draggableReady,
        setViewerLoaded,
        pdfNotProtected,
        setDocumentLoaded,
        setDraggableReady,
        setPdfNotProtected,
    }), [viewerLoaded, documentLoaded, draggableReady, pdfNotProtected]);

    return (
        <PDFStatusContext.Provider value={value}>
            {children}
        </PDFStatusContext.Provider>
    );
}

PDFStatusProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
